import { FaCode, FaVrCardboard, FaCloud, FaBrain } from 'react-icons/fa';
import useDocumentTitle from '../hooks/useDocumentTitle';

const heroImg = require('../Assert/16.jpg');

function Technologies() {
  useDocumentTitle('Technologies — MMI');

  return (
    <main className="technologies-page">
      {/* Hero Section — two-column: text left, image right */}
      <section className="tech-hero">
        <div className="container">
          <div className="hero-two-column">
            <div className="hero-left">
              <h1 className="hero-title">
                The <span className="gradient-text">Tools</span> Behind the
                <br />
                <span className="gradient-text">Work.</span>
              </h1>
              <p className="hero-description">
                We don't collect logos. We use what we know.
              </p>
            </div>
            <div className="hero-right">
              <div className="hero-image-container">
                <img
                  src={heroImg}
                  alt="Technology stacks"
                  className="hero-image"
                />
                <div className="hero-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All stacks — single section, 2×2 grid */}
      <section className="tech-stacks-section">
        <div className="container">
          <div className="tech-stacks-grid">
            <div className="tech-stack-card">
              <div className="category-header">
                <FaBrain className="category-icon" />
                <h2 className="category-title">AI</h2>
              </div>
              <div className="tech-grid">
                <span className="tech-item">OpenAI</span>
                <span className="tech-item">LangChain</span>
                <span className="tech-item">TensorFlow</span>
                <span className="tech-item">HuggingFace</span>
              </div>
            </div>

            <div className="tech-stack-card">
              <div className="category-header">
                <FaCode className="category-icon" />
                <h2 className="category-title">Dev</h2>
              </div>
              <div className="tech-grid">
                <span className="tech-item">React Native</span>
                <span className="tech-item">Rust</span>
                <span className="tech-item">TypeScript</span>
                <span className="tech-item">Wasm</span>
              </div>
            </div>

            <div className="tech-stack-card">
              <div className="category-header">
                <FaVrCardboard className="category-icon" />
                <h2 className="category-title">XR</h2>
              </div>
              <div className="tech-grid">
                <span className="tech-item">Unity</span>
                <span className="tech-item">Spatial UI</span>
                <span className="tech-item">Hand Tracking</span>
                <span className="tech-item">3D Photogrammetry</span>
              </div>
            </div>

            <div className="tech-stack-card">
              <div className="category-header">
                <FaCloud className="category-icon" />
                <h2 className="category-title">Cloud</h2>
              </div>
              <div className="tech-grid">
                <span className="tech-item">Azure</span>
                <span className="tech-item">Kubernetes</span>
                <span className="tech-item">Serverless</span>
                <span className="tech-item">AWS</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stay Ahead Section */}
      <section className="stay-ahead-section">
        <div className="container">
          <div className="stay-ahead-content">
            <h2 className="stay-ahead-title">
              STAY <span className="gradient-text">AHEAD</span>
            </h2>
            <p className="stay-ahead-text">
              Innovation First.
              <br />
              Tools Change. Understanding doesn't.
            </p>
          </div>
        </div>
      </section>

      
    </main>
  );
}

export default Technologies;
